import { TemplateLoader } from './TemplateLoader';
import { DSLLoader } from './DSLLoader';
import { Renderer } from '../render/Renderer';
import { createLanguageSwitcher } from '../i18n/LanguageSwitcher';
import { i18nService, LANGUAGE_CHANGED_EVENT } from '../i18n/I18nService';
import { eventBus } from '../events/EventBus';
import { authService } from '../auth/AuthService';
import { createProfileButton } from '../auth/ProfileButton';
import { getHashParams } from './hashParams';
function resolvePageId() {
    return getHashParams().get('page') || 'home';
}
export class NavigationManager {
    constructor(root) {
        Object.defineProperty(this, "root", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: root
        });
        Object.defineProperty(this, "templateLoader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new TemplateLoader()
        });
        Object.defineProperty(this, "dslLoader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new DSLLoader()
        });
        Object.defineProperty(this, "renderer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Renderer()
        });
        Object.defineProperty(this, "profileButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async start() {
        await Promise.all([i18nService.initialize(), authService.initialize()]);
        this.profileButton = createProfileButton();
        const headerActions = document.createElement('div');
        headerActions.className = 'header-actions';
        headerActions.append(this.profileButton, createLanguageSwitcher());
        document.body.appendChild(headerActions);
        window.addEventListener('hashchange', () => this.navigate());
        eventBus.on(LANGUAGE_CHANGED_EVENT, () => this.navigate());
        await this.navigate();
    }
    async navigate() {
        const pageId = resolvePageId();
        this.profileButton.hidden = pageId === 'admin';
        const [templates, page] = await Promise.all([this.templateLoader.load(), this.dslLoader.load(pageId)]);
        this.renderer.render(this.root, page, templates);
    }
}
